// extracted by mini-css-extract-plugin
export var cardLayout = "_7l-1";
export var paginationContainer = "_7l-0";